

























































































































import { Vue, Component } from 'vue-property-decorator';
import { ObjectFactory } from '../config/objectFactory';
import Menu from '../components/Menu.vue';
import { Condition } from '@/types/queryRequest';
import { AdvanceFilterRequest } from '@/types/request';
import { ModelSelect } from 'vue-search-select';
import { HealthcareProvider, OrgLocation, Patient } from '@/types/entity';
import { MedTransGoConstants } from '@/util/constants';
import DataTable from '@/components/DataTable.vue';
import { DateUtils } from '@/util/dateUtils';
import { MathUtils } from '@/util/mathUtils';
import { ResourceUtils } from '@/util/resourceUtils';
import JSZip from 'jszip';
import ViewRequestDetailModal from './modal/ViewRequestDetailModal.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { MemberProfile } from '@/types/response';

// tslint:disable-next-line: no-var-requires
const ReportsTable = require('../datatable/ReportsTable.json');
// tslint:disable-next-line: no-var-requires
const PatientInvoiceTable = require('../datatable/PatientInvoiceTable');

@Component({
    data() {
        return {
            header: 'Reports',
            menuOptions: [{
                url: 'reports?reportType=service',
                activeConditions: {
                    reportType: 'service',
                },
                label: 'Service Reports',
            },
            {
                url: 'reports?reportType=invoice',
                activeConditions: {
                    reportType: 'invoice',
                },
                label: 'Patient Invoices',
            },
            ],
            serviceOptions: [
                {
                    value: '',
                    text: 'All',
                },
                {
                    value: 'transportRequest',
                    text: 'Transportation',
                },
                {
                    value: 'interpreterRequest',
                    text: 'Interpretation',
                },
                {
                    value: 'telemedicineRequest',
                    text: 'Telemedicine',
                },
                {
                    value: 'deliveryRequest',
                    text: 'Delivery',
                },
                {
                    value: 'homeHealthCareRequest',
                    text: 'HomeHealthCare',
                },
            ],
            statusOptions: [
                {
                    value: '',
                    text: 'All',
                },
                {
                    value: 'Requires Approval',
                    text: 'Requires Approval',
                },
                {
                    value: 'Pending',
                    text: 'Pending',
                },
                {
                    value: 'Confirmed',
                    text: 'Confirmed',
                },
                {
                    value: 'Completed',
                    text: 'Completed',
                },
                {
                    value: 'Canceled',
                    text: 'Canceled',
                },
            ],
            billingLocationOptions: [],
            providersOptions: [],
            patientOptions: [],
        };
    },
    components: {
        Menu,
        ModelSelect,
        DataTable,
        ViewRequestDetailModal,
    },
})
export default class Reports extends Vue {

    private advanceFilterRequest: AdvanceFilterRequest = {};
    private locations: OrgLocation[] = [];
    private healthcareProviders: HealthcareProvider[] = [];
    private service: any | undefined = '';
    private invoice: any | undefined = '';
    private billingLocationId: string | undefined = '';
    private facilityName: string | undefined = '';
    private requestStatus: string | undefined = '';
    private startDate: any | undefined = '';
    private endDate: any | undefined = '';
    private reportsDataSource = ReportsTable;
    private invoiceDataSource = PatientInvoiceTable;
    private patients: Patient[] = [];
    private patientName: string | undefined = '';
    private type: any = 'I';
    private card = '';
    private requestId = '';
    private memberProfile: MemberProfile | undefined;

    public async mounted() {
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile && (this.memberProfile.memberType === 'ORG_MEMBER' || this.memberProfile.memberType === 'ORG_MANAGER')) {
            const indexToRemove = this.$data.menuOptions.findIndex((option: any) =>
                option.activeConditions.reportType === 'invoice');
            if (indexToRemove !== -1) {
                this.$data.menuOptions.splice(indexToRemove, 1);
            }
        }
        await this.getOrganizationLocations();
        await this.getHealthcareProviders();
        this.getPatients();
    }

    private async genrateReport(searchString?: string, start?: number, reportType?: string) {
        const requestType = this.service;
        const conditions: Condition[] = [];
        if (this.billingLocationId && this.billingLocationId !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'locationId',
                value: this.billingLocationId,
            };
            conditions.push(condition);
        }
        if (this.facilityName && this.facilityName !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'appointment.facility.name',
                value: this.facilityName,
            };
            conditions.push(condition);
        }
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            this.advanceFilterRequest = {
                appointmentDate: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            };
        }
        if (this.requestStatus && this.requestStatus !== '') {
            if (requestType === 'transportRequest' && (this.requestStatus === 'Pending' || this.requestStatus === 'Confirmed')) {
                if (this.requestStatus === 'Pending') {
                    const newCondiion = {
                        conditions: [{
                            op: 'eq',
                            fieldName: 'status',
                            value: this.requestStatus,
                        },
                        {
                            op: 'eq',
                            fieldName: 'transportRequest.rideshareService',
                            value: false,
                        }],
                        op: 'and',
                    };
                    conditions.push(newCondiion as any);
                }
                if (this.requestStatus === 'Confirmed') {
                    conditions.push({
                        conditions: [
                            {
                                fieldName: 'status',
                                op: 'eq',
                                value: 'Confirmed',
                            },
                            {
                                conditions: [{
                                    op: 'eq',
                                    fieldName: 'status',
                                    value: 'Pending',
                                },
                                {
                                    op: 'eq',
                                    fieldName: 'transportRequest.rideshareService',
                                    value: true,
                                }],
                                op: 'and',
                            },
                        ],
                        op: 'or',
                    });
                }
            } else {
                const condition: Condition = {
                    op: 'eq',
                    fieldName: 'status',
                    value: this.requestStatus,
                };
                conditions.push(condition);
            }
        }
        if (searchString) {
            this.advanceFilterRequest.searchString = searchString;
            conditions.push({
                conditions: [{
                    fieldName: 'requestId',
                    op: 'eq',
                    value: this.advanceFilterRequest.searchString,
                },
                {
                    fieldName: 'appointment.patient.fullName',
                    op: 'regex',
                    value: this.advanceFilterRequest.searchString,
                },
                {
                    fieldName: 'appointment.patient.caseNumber',
                    op: 'regex',
                    value: this.advanceFilterRequest.searchString,
                },
            ],
                op: 'or',
                fieldName: '',
                value: undefined,
            });
        } else {
            this.advanceFilterRequest.searchString = '';
        }
        const response = await ObjectFactory.getRequestService().getRequests({
            baseURL: this.$store.state.serverUrl,
            advanceSearchRequest: this.advanceFilterRequest,
            service: requestType,
            conditions,
            start: start ? start : 0,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
            responseType: reportType as any,
        });
        if (response.success && response.data) {
            response.data.forEach((element) => {
            try {
                const serviceRequest = element;
                if (serviceRequest.transportRequest && serviceRequest.interpreterRequest) {
                    serviceRequest.serviceType = 'Transportation & Interpretation';
                } else if (serviceRequest.interpreterRequest && serviceRequest.telemedicineRequest) {
                    serviceRequest.serviceType = `Telemedicine & Interpretation (${serviceRequest.interpreterRequest.serviceType})`;
                } else if (serviceRequest.telemedicineRequest) {
                    serviceRequest.serviceType = 'Telemedicine';
                } else if (serviceRequest.transportRequest) {
                    serviceRequest.serviceType = 'Transportation';
                } else if (serviceRequest.interpreterRequest) {
                    serviceRequest.serviceType = `Interpretation (${serviceRequest.interpreterRequest.serviceType})`;
                } else if (serviceRequest.deliveryRequest) {
                    serviceRequest.serviceType = 'Medication Delivery';
                } else if (serviceRequest.cmrRequest) {
                    serviceRequest.serviceType = 'Comprehensive Medication Review';
                } else if (serviceRequest.transportRequest && serviceRequest.homeAssistanceRequest) {
                    serviceRequest.serviceType = 'Transportation + Home Assistance';
                } else if (serviceRequest.homeHealthCareRequest) {
                    serviceRequest.serviceType = `HomeHealthCare (${serviceRequest.homeHealthCareRequest.serviceType})`;
                }
                element.appointment.date =  DateUtils.formatDate(serviceRequest.appointment.timestamp,
                   'MM/DD/YYYY') as any;
                element.appointment.timestamp = DateUtils.formatDate(serviceRequest.appointment.timestamp,
                   'hh: mm a z' , serviceRequest.appointment.facility.address.timezone) as any;
                if (element.payment) {
                    let depositAmount = 0;
                    const estimatedFare = element.payment.estimatedFare;
                    estimatedFare.particulars.forEach((particular) => {
                        if (particular.description === 'Deposit (Refundable)') {
                            depositAmount += particular.amount;
                        }
                    });
                    element.payment.estimatedFare.totalAmount = MathUtils.formatCurrency
                        (element.payment.estimatedFare.totalAmount - depositAmount) as any;
                    if (element.payment.paymentResponse) {
                        element.payment.paymentResponse.amount = MathUtils.formatCurrency
                            (element.payment.paymentResponse.amount);
                    }
                }
            } catch (error) {
                console.log(error);
            }
            });
            this.reportsDataSource.data = response.data;
            if (response.totalCount) {
                this.reportsDataSource.totalCount = response.totalCount;
            }
        }
    }

    private async getOrganizationLocations() {
        this.$data.billingLocationOptions = [];
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data && this.memberProfile) {
            response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
            this.locations = response.data;
            const managedLocationIds = (this.memberProfile.managedLocations || []).map((ml) => ml.id);
            const locationId = (this.memberProfile.location || {}).id;
            response.data.forEach((location) => {
                if (this.memberProfile && this.memberProfile.memberType === 'ORG_MEMBER'
                    && (location.id !== locationId && !managedLocationIds.includes(location.id))) {
                    return;
                }
                if (this.memberProfile && this.memberProfile.memberType === 'ORG_MANAGER'
                    && !managedLocationIds.includes(location.id)) {
                    return;
                }
                const option = {
                    value: location.id,
                    text: location.locationName,
                };
                this.$data.billingLocationOptions.push(option);
            });
            const allOption = {
                value: '',
                text: 'All',
            };
            this.$data.billingLocationOptions.unshift(allOption);
        }
    }
    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.healthcareProviders = response.data as any;
        this.$data.providersOptions = [];
        this.healthcareProviders.forEach((healthcareProvider) => {
            if (healthcareProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: healthcareProvider.fullname,
                    text: healthcareProvider.fullname,
                };
                this.$data.providersOptions.push(providersOption);
            }
        });
        const allOption = {
            value: '',
            text: 'All',
        };
        this.$data.providersOptions.unshift(allOption);
    }

    private async searchPatientInvoice(searchString?: string, start?: number) {
        this.type = this.$route.query.type ? this.$route.query.type : 'I';
        const conditions: Condition[] = [];
        if (this.patientName && this.patientName !== '') {
            const condition: Condition = {
                op: 'eq',
                fieldName: 'customerName',
                value: this.patientName,
            };
            conditions.push(condition);
        }
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            this.advanceFilterRequest = {
                appointmentDate: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            };
        }
        if (this.memberProfile && (this.memberProfile.memberType === 'ORG_MANAGER' || this.memberProfile.memberType === 'ORG_MEMBER')) {
            const managedLocationIds = (this.memberProfile.managedLocations || []).map((ml) => ml.id);
            if (this.memberProfile.memberType === 'ORG_MEMBER' && this.memberProfile.location) {
                managedLocationIds.push(this.memberProfile.location.id);
            }
            conditions.push({
                op: 'in',
                fieldName: 'billingLocation.id',
                value: managedLocationIds,
            });
        }
        const response = await ObjectFactory.getInvoiceService().getInvoiceList(this.$store.state.serverUrl, {
            conditions,
            advanceFilterRequest: this.advanceFilterRequest,
            start,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
        }, this.type);
        if (response.success && response.data) {
            response.data.forEach((element: any) => {
                if (element.status === 'Approved') {
                    element.status = 'Unpaid';
                }
                element.totalAmount = 0;
                element.particulars.forEach((iElement: any) => {
                    element.totalAmount += iElement.amount;
                });
                element.totalAmount = MathUtils.formatCurrency(element.totalAmount);
                element.createdOn = DateUtils.formatDate(element.createdOn);
            });
            this.invoiceDataSource.data = response.data;
            this.invoiceDataSource.totalCount = response.totalCount;
        }
    }

    private async downloadInvoice(invoice: any) {
        const pdfBuffer = await ObjectFactory.getInvoiceService().
            getInvoiceReceipt(this.$store.state.serverUrl, invoice.id) as any;
        const file = new Blob([pdfBuffer], { type: 'application/pdf' });
        ResourceUtils.downloadFileIntoDevice(file, `${invoice.invoiceId}.pdf`);
    }

    private async getPatients() {
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.patients = response.data as any;
        this.$data.patientOptions = [];
        const managedLocationIds = (this.memberProfile && this.memberProfile.managedLocations || []).map((ml) => ml.id);
        const locationNames: string[] = this.locations
            .filter((location) => managedLocationIds.includes(location.id))
            .flatMap((location) => location.locationName ? [location.locationName] : []);
        this.patients.forEach((patient) => {
            if (this.memberProfile && patient.location) {
                if (this.memberProfile.location && this.memberProfile.memberType === 'ORG_MEMBER'
                    && (patient.location !== this.memberProfile.location.name &&
                        !locationNames.includes(patient.location))) {
                    return;
                }
                if (this.memberProfile && this.memberProfile.memberType === 'ORG_MANAGER'
                    && !managedLocationIds.includes(patient.location)) {
                    return;
                }
                const patientOption = {
                    value: patient.fullName,
                    text: patient.fullName,
                };
                this.$data.patientOptions.push(patientOption);
            }
        });
        const allOption = {
            value: '',
            text: 'All',
        };
        this.$data.patientOptions.unshift(allOption);
    }

    private async downloadZipFile() {
        const conditions: Condition[] = [];
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            this.advanceFilterRequest = {
                appointmentDate: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                },
            };
            if (this.patientName && this.patientName !== '') {
                const condition: Condition = {
                    op: 'eq',
                    fieldName: 'customerName',
                    value: this.patientName,
                };
                conditions.push(condition);
            }
            conditions.push({
                op: 'ne',
                fieldName: 'status',
                value: 'Pending',
            });
            const response = await ObjectFactory.getInvoiceService().getInvoiceList(this.$store.state.serverUrl, {
                conditions,
                advanceFilterRequest: this.advanceFilterRequest,
                limit:  MedTransGoConstants.DB_QUERY_MAX_RESULT,
            }, this.type);
            if (response.success && response.data && response.data.length) {
                const resourceIds: string[] = response.data.map((element: any) => element.pdfResourceId)
                .filter(Boolean);
                if (resourceIds.length > 0) {
                    await this.downloadZip(resourceIds, 'Invoices');
                    const toastEvent: ToastEvent = {
                        message: 'Invoice file downloaded successfully!',
                        title: 'Success',
                        timeout: 2000,
                        varient: 'success',
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                }
            }
        } else {
            const toastEvent: ToastEvent = {
                message: 'Please select valid date range',
                title: 'Error',
                timeout: 5000,
                varient: 'danger',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private async downloadZip(resourceIds: string[], fileName: string): Promise<void> {
    try {
        const zip = new JSZip();
        const pdfPromises = resourceIds.map(async (resourceId) => {
            const pdfUrl =  await ResourceUtils.getResourceUrl(this.$store.state.serverUrl,
                    resourceId) as any;
            const response = await fetch(pdfUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch PDF with ID: ${resourceId}`);
            }
            const pdfBlob = await response.blob();
            zip.file(`${resourceId}.pdf`, pdfBlob);
        });
        await Promise.all(pdfPromises);
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const fileURL = URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `${fileName}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
    } catch (error) {
        console.error('Error while downloading the ZIP file:', error);
    }
}

    private showViewRequestModal(serviceRequest: any) {
        this.requestId = serviceRequest.id;
    }
}
